/**
 * Shared validation constants
 *
 * This file contains reusable validation patterns and constraints
 * used across schemas and application logic.
 */
/**
 * Activation code format constants
 *
 * Activation codes are 16 uppercase alphanumeric characters.
 * They may be displayed with dashes for readability (XXXX-XXXX-XXXX-XXXX)
 * but are stored without dashes in the database.
 */
/** Length of activation code without dashes */
export const ACTIVATION_CODE_LENGTH = 16;
/** Length of activation code with dashes (16 chars + 3 dashes) */
export const ACTIVATION_CODE_FORMATTED_LENGTH = 19;
/**
 * Regex pattern for activation codes
 *
 * Matches either:
 * - 16 uppercase alphanumeric characters (stored format): AAAAAAAAAAAAAAAA
 * - 16 characters with dashes every 4 chars (display format): AAAA-AAAA-AAAA-AAAA
 */
export const ACTIVATION_CODE_PATTERN = /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$|^[A-Z0-9]{16}$/;
/**
 * Regex pattern for stored activation codes (no dashes)
 *
 * Matches: AAAAAAAAAAAAAAAA
 */
export const ACTIVATION_CODE_STORAGE_PATTERN = /^[A-Z0-9]{16}$/;
/** Error message for invalid activation code format */
export const ACTIVATION_CODE_ERROR_MESSAGE = 'Activation code must be 16 alphanumeric characters (with or without dashes)';
/** Error message for invalid stored activation code format */
export const ACTIVATION_CODE_STORAGE_ERROR_MESSAGE = 'Activation code must be exactly 16 uppercase alphanumeric characters';
//# sourceMappingURL=validation.js.map